<router-outlet></router-outlet>
<kanzi-session-expired-dialog></kanzi-session-expired-dialog>
@if(!isProduction){
<angular-query-devtools />
}
